import * as React from 'react';
import { FullScreen } from '@/layouts/page-layout';

import { State404 } from '@/components/public/state404';

export const NotFound: React.FC = () => {
  return (
    <FullScreen>
      <State404 />
    </FullScreen>
  );
};

export default NotFound;
